export default "__VITE_ASSET__VUVSNVIq__"